type HostedAppointment = { isExternalHost?: boolean; regBy?: { id: number } | null };

export function isAppointmentHost(appointment: HostedAppointment, userId: number): boolean {
	return !appointment.isExternalHost && appointment.regBy?.id === userId;
}
